import React from 'react';
import { SEO } from '../components/seo/SEO';
import { MarkdownPage } from '../components/content/MarkdownPage';
import content from '../content/insights/csrd-esg-tech.md?raw';

export const InsightsCsrdEsg: React.FC = () => {
  return (
    <>
      <SEO
        title="CSRD/ESG Tech Stack"
        description="Data pipelines, dashboards, and audit trails for CSRD/ESG reporting with auditability."
        canonical="/insights/csrd-esg-tech"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: 'CSRD/ESG Tech Stack',
          description:
            'Data pipelines, dashboards, and audit trails for CSRD/ESG reporting with auditability.',
          author: { '@type': 'Organization', name: 'Integrova AI GmbH' },
          publisher: {
            '@type': 'Organization',
            name: 'Integrova AI GmbH',
            logo: { '@type': 'ImageObject', url: 'https://integrovaai.de/og-default.png' },
          },
          mainEntityOfPage: { '@type': 'WebPage', '@id': 'https://integrovaai.de/insights/csrd-esg-tech' },
          datePublished: '2025-12-20',
          dateModified: '2025-12-20',
        }}
      />
      <MarkdownPage
        title="CSRD/ESG Tech Stack"
        eyebrow="Insights"
        content={content}
      />
    </>
  );
};

export default InsightsCsrdEsg;
